import { msg } from "@lingui/core/macro";

export const disableEditPermitRuleMessages = {
	name: msg({ message: "Parkers Can Edit" }),
	description: msg({ message: "Parkers can edit their own permit" }),
	errors: {
		disabled: msg({ message: "Edit permit is not enabled for this event." }),
	},
} as const;
